export default __webpack_public_path__ + "static/media/hht1_direction_eggstudio_03.a0beb9f1.png";